<header class="bg-dc-gradient">
  @if(parentRouteName == "service"){
  <button type="button" (click)="back()" class="absolute left-4">
    <img src="/icons/svg/back.svg">
    <!-- {{ "BACK" | translate }} -->
  </button>
  }
  <!-- Centered logo -->
  <div class="absolute left-1/2 transform -translate-x-1/2">
     <img
       [src]="currentLogo"
       alt="Logo"
       class="lg:block select-none"
       (dblclick)="onLogoDoubleClick($event)"
     />
  </div>
</header>

<div class="flex flex-col bg-gray-100">
    <router-outlet></router-outlet>
</div>
